<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="text-center">
        <v-col cols="12" class="mx-auto">
          <v-rating
            :length="question.allowed_options"
            align="center"
            class="survey-rating mb-3"
            readonly
            data-testid="rating-numbers"
          >
            <template v-slot:item="props">
              <v-icon
                :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                :color="props.isFilled ? 'accent' : ''"
                v-text="`mdi-numeric-${props.index + 1}`"
                @click="props.click"
                large
              ></v-icon>
            </template>
          </v-rating>
          <span
            v-for="option in question.allowed_options"
            :key="option"
            class="d-inline-block star"
            id="data-html2canvas-rating-percentages"
          >
            <span
              v-if="
                question.stats &&
                question.stats.hasOwnProperty(option) &&
                question.stats[option]
              "
            >
              <span
                >{{
                  calculatePercentage(question.stats[option], numbSubmissions)
                }}%</span
              >
            </span>
            <span v-else>
              <span>0%</span>
            </span>
          </span>
          <p class="mt-3 mb-3 go-to-answers-row">
            {{ $t("surveyGoToIndividualstab") }}
          </p>
          <v-btn
            data-testid="go-to-answers-button"
            type="submit"
            color="accent"
            min-width="260"
            dark
            elevation="0"
            class="rounded-l text-none px-4 mb-5 white--text go-to-answers-row"
            @click="redirectToIndividualAnswers"
          >
            {{ $t("goToAnswers")}}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mx-auto">
          <v-rating
            v-if="user[question.qid] && user[question.qid].answer.rating"
            :length="question.allowed_options"
            align="center"
            class="survey-rating"
            readonly
            data-testid="rating-numbers"
            :value="user[question.qid].answer.rating"
          >
            <template v-slot:item="props">
              <v-icon
                :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                :color="props.isFilled ? 'accent' : ''"
                v-text="`mdi-numeric-${props.index + 1}`"
                @click="props.click"
                large
              ></v-icon>
            </template>
          </v-rating>
          <v-col cols="12" sm="12" :md="pdf ? 9 : 7" class="mx-auto">
            <v-textarea
              dense
              outlined
              readonly
              :value="user[question.qid].answer.answer"
              rows="4"
              cols="50"
            ></v-textarea>
          </v-col>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-rating
        :value=0
        :length="question.allowed_options"
        align="center"
        class="survey-rating"
        readonly
        data-testid="rating-numbers"
      >
        <template v-slot:item="props">
          <v-icon
            :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
            :color="props.isFilled ? 'accent' : ''"
            v-text="`mdi-numeric-${props.index + 1}`"
            @click="props.click"
            large
          ></v-icon>
        </template>
      </v-rating>
      <v-col cols="12" sm="12" :md="pdf ? 9 : 7" class="mx-auto">
        <v-textarea
          dense
          outlined
          disabled
          class="survey-rating-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
          :placeholder="$t('surveyTextareaParticipantPlaceholder')"
          data-testid="rating-textarea"
        />
      </v-col>
    </div>
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    numbSubmissions: {
      type: Number,
      default: 0,
    },
    user: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [repeatedMethodsMixin],
  methods: {
    redirectToIndividualAnswers(){
      this.$router.push({name: 'SurveyIndividuals', params: {id: this.$route.params.id, surveyId: this.$route.params.surveyId}})
    }
  }
};
</script>
